/*
  Shared loader for the Vimeo Player API, used by both the background-video
  handling and the video-widget lightbox module. A single shared loader keeps
  the script from being requested twice when both features run on the same
  page.
*/

var VIMEO_API_SRC = 'https://player.vimeo.com/api/player.js';

export function loadVimeoApi(callback) {
    if (window.Vimeo && window.Vimeo.Player) {
        callback();
        return;
    }

    var existingScript = document.querySelector('script[src="' + VIMEO_API_SRC + '"]');

    if (existingScript) {
        existingScript.addEventListener('load', callback);
        return;
    }

    var script = document.createElement('script');
    script.src = VIMEO_API_SRC;
    script.onload = callback;
    document.head.appendChild(script);
}
